import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { App } from './App';
const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false
  },
  styles: {
    global: {
      body: {
        bg: '#0a0a0a',
        color: 'white'
      }
    }
  },
  colors: {
    brand: {
      50: '#fdf0ee',
      100: '#f9d5cf',
      200: '#f0a99c',
      300: '#e07a66',
      400: '#d13a28',
      500: '#b8291a',
      600: '#8f1e13',
      700: '#6b160e',
      800: '#450d08',
      900: '#1f0503'
    },
    fire: {
      50: '#fff4ec',
      100: '#ffe0c7',
      200: '#fbc090',
      300: '#f59a58',
      400: '#f2802f',
      500: '#e8631a',
      600: '#c24d10',
      700: '#93390b',
      800: '#652707',
      900: '#3a1503'
    },
    gold: {
      50: '#fff8ea',
      100: '#fdecc6',
      200: '#f9d891',
      300: '#f5c364',
      400: '#f2a93b',
      500: '#e5952a',
      600: '#c07621',
      700: '#8f561a',
      800: '#5e3811',
      900: '#2f1c08'
    },
    call: {
      50: '#eaf1fd',
      100: '#c7daf9',
      200: '#94b8f2',
      300: '#6194eb',
      400: '#4380e6',
      500: '#2d6fe0',
      600: '#2158b6',
      700: '#19428a',
      800: '#112c5c',
      900: '#08162e'
    }
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Inter', sans-serif"
  }
});
function Root() {
  useEffect(() => {
    document.title = 'Maestros Ancestrales | Consulta Espiritual Personalizada';

    // Defer GTM loading to prioritize page content
    const gtmTimeout = setTimeout(() => {
      ;
      (function (w: any, d: Document, s: string, l: string, i: string) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0] as HTMLElement;
        var j = d.createElement(s) as HTMLScriptElement;
        var dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        if (f && f.parentNode) {
          f.parentNode.insertBefore(j, f);
        } else {
          d.head.appendChild(j);
        }
      })(window, document, 'script', 'dataLayer', 'GTM-WK5ZP7PJ');
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WK5ZP7PJ';
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }, 3000);
    return () => clearTimeout(gtmTimeout);
  }, []);
  return <ChakraProvider theme={theme} data-id="element-81" data-mp="175lyodmpjklj">
      <App data-id="element-82" data-mp="1727t6wiqyv9v" />
    </ChakraProvider>;
}
render(<Root data-id="element-83" data-mp="1c3nhcxg81hwh" />, document.getElementById('root'));